module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "not-found"
  }, [_c('div', {
    staticClass: "not-found__message text-xs-center"
  }, [_vm._m(0), _vm._v(" "), _c('h4', [_vm._v("SE PRODUJO UN ERROR EN EL SERVIDOR")]), _vm._v(" "), (_vm.$store.state.message) ? _c('div', {
    staticClass: "error-500"
  }, [_vm._v("\n      " + _vm._s(_vm.$store.state.message) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("arrow_back")]), _vm._v(" Volver atrás")], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("5")]), _vm._v("0"), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v("0")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-859d9c28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/layout/pages/AppError.vue
// module id = 533
// module chunks = 2